/**
 * 认证工具函数
 */

/**
 * 获取存储的 token
 */
export const getToken = (): string | null => {
  return localStorage.getItem('access_token');
};

/**
 * 保存 token
 */
export const saveToken = (token: string): void => {
  localStorage.setItem('access_token', token);
};

/**
 * 删除 token（登出）
 */
export const removeToken = (): void => {
  localStorage.removeItem('access_token');
  localStorage.removeItem('user_info');
};

/**
 * 检查是否已登录
 */
export const isLogin = (): boolean => {
  return !!getToken();
};

/**
 * 保存用户信息
 */
export const saveUserInfo = (userInfo: any): void => {
  localStorage.setItem('user_info', JSON.stringify(userInfo));
};

/**
 * 获取用户信息
 */
export const getUserInfo = (): any => {
  const info = localStorage.getItem('user_info');
  return info ? JSON.parse(info) : null;
};
